<template>
  <div id="loader">
    <div class="loader-content">
      <div class="spinner"></div>
    </div>
  </div>
</template>
<script>
export default {
  name: "Loader"
};
</script>

<style>
/* Fullscreen loader styles */
#loader {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: #fff; /* Change this to your preferred background color */
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
}

.loader-content {
  text-align: center;
}

.spinner {
  width: 40px;
  height: 40px;
  margin: 0 auto 20px;
  border: 4px solid #333; /* Change this to your preferred spinner color */
  border-top-color: transparent;
  border-radius: 50%;
  animation: spin 1s linear infinite;
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/Loader.vue